import { render } from "./LoanCalcModal.vue?vue&type=template&id=a9ed1b5a"
import script from "./LoanCalcModal.vue?vue&type=script&lang=js"
export * from "./LoanCalcModal.vue?vue&type=script&lang=js"
script.render = render

export default script